import utils from 'utils';

import {List, ListItem, ListItemText, ListItemButton} from '@mui/material';

import {UiButton, UiPopover} from '@components/export';
import {useLabel, useUiPopover} from '@/hooks/export';

export const DetailAdditionalPayment = (props: {
    additionalPaymentList: apiOrderLine[],
    locked?: boolean

    onAdditionalPaymentAdd: (value: string) => void,
}) => {
    const label = useLabel();

    const popoverData = useUiPopover();

    return <>
        <UiButton
            style={2}
            text={''}
            icon={'iconfa-money'}
            onClick={(e) => {
                popoverData.handleClick(e);
            }}
            disabled={props.locked}
        />
        <UiPopover
            anchorEl={popoverData.anchorEl}
            setAnchorEl={popoverData.setAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: -5,
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
        >
            <List disablePadding>
                {props.additionalPaymentList.map((item) => (
                    <ListItem
                        key={item.id}
                        disablePadding
                        onClick={() => {
                            props.onAdditionalPaymentAdd(item.id);
                            popoverData.handleClose();
                        }}
                    >
                        <ListItemButton>
                            <ListItemText
                                primary={
                                    <div className={classMap.itemText}>
                                        <span>{item.name}</span>
                                        <span>{item.price + ' ' + label.currency}</span>
                                    </div>
                                }
                            />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </UiPopover>
    </>;
};

const cmpClass = 'detail-additional-payment';

const classMap = utils.generateClassMap(cmpClass, {
    itemText: 'item-text',
});
